export enum CloudBerryDiscountState {
  Approved = 'Approved',
  NotApproved = 'NotApproved',
  NotFound = 'NotFound',
  Pending = 'Pending'
}
